(function () {
  function getTokenFromUrl() {
    var params = new URLSearchParams(window.location.search);
    return params.get('token');
  }

  async function tryIdentifyFromToken() {
    var token = getTokenFromUrl();
    if (token) {
      var btn = document.querySelector('[data-preorder-btn]');
      if (btn) btn.disabled = true;
      localStorage.setItem('preorder_access_pending', 'true');
      let waited = 0;
      while (!window._learnq && waited < 3000) {
        await new Promise((r) => setTimeout(r, 50));
        waited += 50;
      }
      if (window._learnq) {
        window._learnq.push(['identify', { $id: token }]);
        await new Promise((r) => setTimeout(r, 400));
      }
      localStorage.setItem('preorder_access', 'true');
      localStorage.removeItem('preorder_access_pending');
      if (btn) btn.disabled = false;
    }
  }

  tryIdentifyFromToken();
  function getTranslation(key) {
    if (window.theme && window.theme.translations && window.theme.translations.preorder_popup) {
      return window.theme.translations.preorder_popup[key] || '';
    }
    var fallback = {
      title: 'Preorder Access',
      desc: 'Enter your email to request preorder access:',
      email_placeholder: 'Email',
      submit: 'Submit',
      close: 'Close',
      error: 'Please enter a valid email.',
      success: 'Success! Check your email for further instructions.',
    };
    return fallback[key] || '';
  }

  function createPreorderPopup() {
    if (document.getElementById('preorder-popup')) return;
    var popup = document.createElement('div');
    popup.id = 'preorder-popup';
    popup.innerHTML = `
      <div class="preorder-popup__content">
        <h3 class="preorder-popup__title">${getTranslation('title')}</h3>
        <p class="preorder-popup__desc">${getTranslation('desc')}</p>
        <input class="preorder-popup__email input" type="email" id="preorder-popup-email" placeholder="${getTranslation('email_placeholder')}" />
        <div class="preorder-popup__error" id="preorder-popup-error"></div>
        <div class="preorder-popup__buttons">
          <button id="preorder-popup-submit">${getTranslation('submit')}</button>
          <button id="preorder-popup-close">${getTranslation('close')}</button>
        </div>
      </div>
    `;
    document.body.appendChild(popup);

    document.getElementById('preorder-popup-close').onclick = function () {
      popup.remove();
    };
    document.getElementById('preorder-popup-submit').onclick = function () {
      var email = document.getElementById('preorder-popup-email').value;
      var error = document.getElementById('preorder-popup-error');
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
        error.textContent = getTranslation('error');
        error.style.display = 'block';
        return;
      }
      error.style.display = 'none';
      if (window._learnq) {
        window._learnq.push(['identify', { email: email }]);
        window._learnq.push(['track', 'Preorder Access']);
      }
      popup.innerHTML = `<div class=\"preorder-popup__content\">${getTranslation('success')}</div>`;
      setTimeout(function () {
        popup.remove();
      }, 2000);
    };
  }

  function showCookieConsentBanner() {
    var cookieDialog = document.querySelector('#CybotCookiebotDialog');
    if (cookieDialog) {
      cookieDialog.classList.add('active');
      var allowBtn = cookieDialog.querySelector('#CybotCookiebotDialogBodyLevelButtonLevelOptinAllowAll');
      if (allowBtn) allowBtn.focus();
    }
  }

  function showCookieRequiredMessage() {
    var msg = document.createElement('div');
    var locale =
      window.Shopify && window.Shopify.locale
        ? window.Shopify.locale
        : window.theme && window.theme.locale
          ? window.theme.locale
          : 'en';
    var translation = getTranslation('cookie_required');
    if (
      !translation &&
      window.theme &&
      window.theme.translations &&
      window.theme.translations['en'] &&
      window.theme.translations['en'].preorder_popup
    ) {
      translation = window.theme.translations['en'].preorder_popup.cookie_required;
    }
    msg.textContent = translation || 'To place a preorder, you must accept cookies.';
    msg.style.position = 'fixed';
    msg.style.top = '20px';
    msg.style.left = '50%';
    msg.style.transform = 'translateX(-50%)';
    msg.style.background = '#141414';
    msg.style.color = '#fff';
    msg.style.padding = '12px 24px';
    msg.style.zIndex = '1000000';
    msg.style.boxShadow = '0 2px 8px rgba(0,0,0,0.15)';
    msg.style.opacity = '0';
    msg.style.transition = 'opacity 0.4s';
    msg.id = 'preorder-cookie-required-msg';
    document.body.appendChild(msg);
    setTimeout(function () {
      msg.style.opacity = '1';
    }, 10);
    setTimeout(function () {
      msg.style.opacity = '0';
      setTimeout(function () {
        if (msg.parentNode) msg.parentNode.removeChild(msg);
      }, 400);
    }, 4000);
  }

  function onPreorderButtonClick(e) {
    var preorderAccess = localStorage.getItem('preorder_access');
    var preorderPending = localStorage.getItem('preorder_access_pending');
    if (preorderPending === 'true') {
      e.preventDefault();
      var msg = document.createElement('div');
      msg.textContent = getTranslation('preorder_pending') || 'Please wait, access is being granted...';
      msg.style.position = 'fixed';
      msg.style.top = '20px';
      msg.style.left = '50%';
      msg.style.transform = 'translateX(-50%)';
      msg.style.background = '#141414';
      msg.style.color = '#fff';
      msg.style.padding = '12px 24px';
      msg.style.zIndex = '1000000';
      msg.style.borderRadius = '6px';
      msg.style.boxShadow = '0 2px 8px rgba(0,0,0,0.15)';
      msg.style.opacity = '0';
      msg.style.transition = 'opacity 0.4s';
      msg.id = 'preorder-pending-msg';
      document.body.appendChild(msg);
      setTimeout(function () {
        msg.style.opacity = '1';
      }, 10);
      setTimeout(function () {
        msg.style.opacity = '0';
        setTimeout(function () {
          if (msg.parentNode) msg.parentNode.removeChild(msg);
        }, 400);
      }, 2500);
      return;
    }
    if (preorderAccess !== 'true') {
      if (
        window.Shopify &&
        window.Shopify.customerPrivacy &&
        typeof window.Shopify.customerPrivacy.userCanBeTracked === 'function'
      ) {
        if (!window.Shopify.customerPrivacy.userCanBeTracked()) {
          e.preventDefault();
          document.cookie.split(';').forEach(function (c) {
            if (c.trim().startsWith('CookieConsent=')) {
              document.cookie = 'CookieConsent=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/';
            }
          });
          showCookieConsentBanner();
          showCookieRequiredMessage();
          return;
        }
      }
      e.preventDefault();
      createPreorderPopup();
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    var btn = document.querySelector('[data-preorder-btn]');
    if (btn) {
      btn.addEventListener('click', onPreorderButtonClick);
    }
  });

  if (window.theme && window.theme.translations && window.theme.translations.preorder_popup) {
    if (!window.theme.translations.preorder_popup.cookie_required) {
      window.theme.translations.preorder_popup.cookie_required = 'For preorder, you must accept cookies.';
    }
    if (!window.theme.translations.preorder_popup.preorder_pending) {
      window.theme.translations.preorder_popup.preorder_pending = 'Please wait, access is being granted...';
    }
  }
})();
